import QRCode from "qrcode";

class QRCodeGenerator {
    /**
     * Genera un'immagine del codice QR come URL base64
     * @param {string} text - Il testo o URL da includere nel codice QR
     * @param {number} size - La dimensione del codice QR (opzionale)
     * @returns {Promise<string>} - URL base64 del codice QR
     */
    static async generateQRCode(text, size = 256) {
        try {
            const options = {
                width: size,
                margin: 1,
            };
            const qrCodeURL = await QRCode.toDataURL(text, options);
            // console.log(text, qrCodeURL);
            return qrCodeURL;
        } catch (error) {
            console.error("Errore durante la generazione del codice QR:", error);
            throw error;
        }
    }

    /**
     * Scarica un'immagine del codice QR
     * @param {string} url - URL base64 del codice QR
     * @param {string} fileName - Nome del file per il download
     */
    static async downloadQRCode(url, fileName, ) {
        try {
            const link = document.createElement("a");
            link.href = url;
            link.download = `${fileName}.png`;
            link.click();
        } catch (error) {
            console.error("Errore durante il download del codice QR:", error);
        }
    }
}

export default QRCodeGenerator;
